import _ from '@lodash';
import React, { useState } from 'react';
import { TableCell, Tooltip, IconButton } from '@material-ui/core';
import Stop from '@material-ui/icons/Stop';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';

import MeasurementEditService from '../service/MeasurementEditService';

function MeasurementStopRecordingButton(props) {
	const dispatch = useDispatch();
	const stopRecording = () => { MeasurementEditService.stop(props.item.id).then(resp => { dispatch(showMessage({message: 'Recording stopped...'})) }); };

	return (
		<TableCell className="text-center" padding="none">
			<Tooltip title="Stop Recording">
				<span>
					<IconButton onClick={() => stopRecording()}>
						<Stop fontSize="small" />
					</IconButton>
				</span>
			</Tooltip>
		</TableCell>
	);
}

export default MeasurementStopRecordingButton;
